import React from "react";
import {
  Box,
  Grid,
  Skeleton,
  Container
} from "@mui/material";
import Loader from "../../components/loader";

const Homeskeleton = () => {
  return (
    <>
      <Container maxWidth="lg" sx={{ py: 4 }}>
        {/* First Large Banner Skeleton */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 5 }}>
          <Skeleton
            variant="rectangular"
            width="100%"
            height={300}
            sx={{
              maxWidth: 900,
              backgroundColor: "#e0e0e0",
              borderRadius: 2,
              boxShadow: 1,
            }}
          />
        </Box>

        {/* First Row of Cards */}
        <Grid container spacing={3} justifyContent="center" mb={5}>
          {[1, 2, 3].map((item) => (
            <Grid item xs={12} sm={6} md={4} key={item}>
              <Skeleton
                variant="rectangular"
                height={220}
                sx={{
                  backgroundColor: "#e0e0e0",
                  borderRadius: 2,
                  boxShadow: 1,
                }}
              />
            </Grid>
          ))}
        </Grid>

        {/* Center Text Skeleton */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 5 }}>
          <Skeleton
            variant="text"
            width={115}
            height={30}
            sx={{ backgroundColor: "#e0e0e0" }}
          />
        </Box>

        {/* Two Wide Cards */}
        <Grid container spacing={3} justifyContent="center" mb={5}>
          {[1, 2].map((item) => (
            <Grid item xs={12} md={6} key={item}>
              <Skeleton
                variant="rectangular"
                height={300}
                sx={{
                  backgroundColor: "#e0e0e0",
                  borderRadius: 2,
                  boxShadow: 1,
                }}
              />
            </Grid>
          ))}
        </Grid>

        {/* Centered Button Skeleton */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 5 }}>
          <Skeleton
            variant="rectangular"
            width={250}
            height={50}
            sx={{ backgroundColor: "#e0e0e0", borderRadius: 1, boxShadow: 1 }}
          />
        </Box>

        {/* Final Row of Cards */}
        <Grid container spacing={3} justifyContent="center">
          {[1, 2, 3, 4].map((item) => (
            <Grid item xs={12} sm={6} md={3} key={item}>
              <Skeleton
                variant="rectangular"
                height={220}
                sx={{
                  backgroundColor: "#e0e0e0",
                  borderRadius: 2,
                  boxShadow: 1,
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Loader */}
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <Loader />
      </Box>
    </>
  );
};

export default Homeskeleton;
